import React from "react";
import Navbar from "../../Navbar/Navbar";
import ModelCategory from "./ModelCategory";
import ScroollTableCategory from "./ScroollTableCategory";
import { ProductConsumer } from "../../Context/AddProWakel";
import "../shared/rtl-panel.css";

// Category manager (CATEGORY_API.md §4, task A). List/create/edit/reorder/
// hide/delete categories, plus the one-time backfill seed (task C).
class AllCategoryPage extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <ProductConsumer>
                    {(value) => <CategoryBody value={value} />}
                </ProductConsumer>
                <ModelCategory />
            </div>
        );
    }
}

class CategoryBody extends React.Component {
    componentDidMount() {
        this.props.value.CT_getCategories();
    }

    render() {
        const {
            CT_categories,
            CT_loading,
            CT_search,
            CT_searchChange,
            CT_getCategories,
            CT_OpenCreate,
            CT_backfill,
            CT_backfilling,
            CT_deleteAllCategories,
            CT_deletingAll
        } = this.props.value;

        return (
            <div className="rs-page" dir="rtl">
                <div className="rs-toolbar">
                    <h5 className="rs-toolbar__title">
                        <i className="fas fa-tags"></i>
                        بەڕێوەبردنی جۆرەکان
                    </h5>

                    <span className="rs-badge rs-badge--grey rs-num">
                        {CT_categories.length}
                    </span>

                    <span className="rs-toolbar__sep" />

                    <div className="rs-field rs-field--grow">
                        <label className="rs-field__label" htmlFor="CT_search">
                            گەڕان
                        </label>
                        <input
                            id="CT_search"
                            type="text"
                            name="CT_search"
                            value={CT_search}
                            onChange={CT_searchChange}
                            placeholder="گەڕان بە ناوی جۆر..."
                            className="rs-input"
                        />
                    </div>

                    <button className="rs-btn rs-btn--primary" onClick={CT_OpenCreate}>
                        <i className="fas fa-plus"></i>
                        جۆری نوێ
                    </button>

                    <button
                        className="rs-btn rs-btn--ghost"
                        onClick={() => CT_backfill(false)}
                        disabled={CT_backfilling}
                        title="دروستکردنی جۆرەکان لە ناوی کاڵاکانەوە (یەک جار)"
                    >
                        {CT_backfilling ? (
                            <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                            <>
                                <i className="fas fa-magic"></i>
                                Backfill
                            </>
                        )}
                    </button>

                    <button
                        className="rs-btn rs-btn--ghost"
                        onClick={CT_getCategories}
                        disabled={CT_loading}
                    >
                        {CT_loading ? (
                            <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                            <>
                                <i className="fas fa-sync"></i>
                                نوێکردنەوە
                            </>
                        )}
                    </button>

                    <button
                        className="rs-btn rs-btn--danger"
                        onClick={CT_deleteAllCategories}
                        disabled={CT_deletingAll || CT_categories.length === 0}
                        title="سڕینەوەی هەموو جۆرەکان"
                    >
                        {CT_deletingAll ? (
                            <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                            <>
                                <i className="fas fa-trash-alt"></i>
                                سڕینەوەی هەموو
                            </>
                        )}
                    </button>
                </div>

                <ScroollTableCategory />
            </div>
        );
    }
}

export default AllCategoryPage;
